import { render, staticRenderFns } from "./getRecord.vue?vue&type=template&id=22b30188&scoped=true"
import script from "./getRecord.vue?vue&type=script&lang=js"
export * from "./getRecord.vue?vue&type=script&lang=js"
import style0 from "./getRecord.vue?vue&type=style&index=0&id=22b30188&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b30188",
  null
  
)

export default component.exports